import { Preferences } from '@capacitor/preferences'

const STORAGE_KEY = "clinica-glow";

export type GlowLevel = "all" | "medium" | "off";

async function persistGlow(level: GlowLevel) {
  localStorage.setItem(STORAGE_KEY, level);
  try {
    await Preferences.set({ key: STORAGE_KEY, value: level })
  } catch {}
}

async function readGlow(): Promise<GlowLevel | null> {
  const ls = localStorage.getItem(STORAGE_KEY) as GlowLevel | null;
  if (ls === "all" || ls === "medium" || ls === "off") return ls;
  try {
    const { value } = await Preferences.get({ key: STORAGE_KEY })
    if (value === "all" || value === "medium" || value === "off") return value
  } catch {}
  return null
}

export function useGlowSettings() {
  const glowLevel = useState<GlowLevel>("clinica-glow", () => "all");

  function applyGlow(level: GlowLevel) {
    if (!import.meta.client) return;
    document.documentElement.setAttribute("data-glow", level);
  }

  async function initGlow() {
    if (!import.meta.client) return;
    const stored = await readGlow()
    glowLevel.value = stored ?? "all";
    applyGlow(glowLevel.value);
  }

  function setGlow(level: GlowLevel) {
    glowLevel.value = level;
    if (import.meta.client) {
      persistGlow(level);
      applyGlow(level);
    }
  }

  return { glowLevel, initGlow, setGlow };
}
